var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3997 8.64335C12.2407 8.64335 13.7331 7.15097 13.7331 5.31002C13.7331 3.46907 12.2407 1.97668 10.3997 1.97668C8.55879 1.97668 7.06641 3.46907 7.06641 5.31002C7.06641 7.15097 8.55879 8.64335 10.3997 8.64335Z",
    fill: "#780000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0677 14.8934C17.0677 16.9643 17.0677 18.6434 10.401 18.6434C3.73438 18.6434 3.73438 16.9643 3.73438 14.8934C3.73438 12.8226 6.71937 11.1434 10.401 11.1434C14.0827 11.1434 17.0677 12.8226 17.0677 14.8934Z",
    fill: "#780000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.02d77ffa93182fba03b9faa8028de7c3.svg";
export { ForwardRef as ReactComponent };